import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import classNames from "classnames";
import { Fade } from "react-awesome-reveal";
import ScrollContainer from "react-indiana-drag-scroll";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { Asset } from "../../models";

type Props = {
  items: {
    _uid: string;
    image: Asset;
    orientation: "landscape" | "portrait";
  }[];
};

export const ImageCarousel: React.FC<Props> = ({ items }) => (
  <div className={classNames("mt-20", "lg:mt-25", "xl:mt-40")}>
    <ScrollContainer>
      <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
        <div
          className={classNames(
            "flex flex-nowrap gap-5 px-5 after:pe-px after:content-['']",
            "lg:gap-7 lg:px-15 lg:after:pe-8",
            "xl:gap-10 xl:px-22 xl:after:pe-12",
          )}
        >
          {items.map((item) => (
            <div
              key={item._uid}
              className={classNames({
                "h-[412px] min-w-[275px] lg:h-[500px] lg:min-w-[333px] xl:h-[703px] xl:min-w-[468px]":
                  item.orientation === "portrait",
                "h-[238px] min-w-[356px] lg:h-[288px] lg:min-w-[432px] xl:h-[405px] xl:min-w-[608px]":
                  item.orientation === "landscape",
              })}
            >
              <GatsbyImage
                image={getGatsbyImage(item.image.filename, {
                  layout: "fullWidth",
                })}
                alt={item.image.alt}
                className={classNames("h-full w-full rounded-lg")}
              />
            </div>
          ))}
        </div>
      </Fade>
    </ScrollContainer>
  </div>
);
